import extendedFieldHooks from "ExtendedFields/selectorHooks";

import FnrButton from "UI/FnrButton3";

const BackButton = () => {
  const [, setIsNavigating] = extendedFieldHooks.useIsNavigating();

  const handleBack = () => {
    setIsNavigating(true);
  };

  // The main reason for this container div is to make button inline.
  return (
    <div data-cy="ExtendedFields_BackButton" style={{ paddingBottom: "3px" }}>
      <FnrButton onClick={handleBack}>
        <span>Cancel</span>
      </FnrButton>
    </div>
  );
};

export default BackButton;
